import type {
  ChapterListStreamInput,
  ChapterRef,
  ReaderStreamSequence,
  StreamChapterItem,
} from './types';

export function buildCanonicalStreamSequence(chapterRefs: ChapterRef[]): ReaderStreamSequence {
  return {
    kind: 'canonical',
    title: null,
    source: null,
    items: chapterRefs.map((reference, catalogIndex) => ({
      key: `canonical:${catalogIndex}`,
      catalogIndex,
      bookId: reference.bookId,
      chapter: reference.chapter,
      label: null,
    })),
  };
}

export function buildFixedListStreamSequence(
  chapterRefs: ChapterRef[],
  chapterIndexByKey: ReadonlyMap<string, number>,
  input: {
    title?: string | null;
    source?: string | null;
    items: ChapterListStreamInput[];
  },
): ReaderStreamSequence | null {
  const items: StreamChapterItem[] = [];

  for (const [position, item] of input.items.entries()) {
    const catalogIndex = chapterIndexByKey.get(chapterKey(item.bookId, item.chapter));
    if (catalogIndex === undefined) {
      continue;
    }

    const reference = chapterRefs[catalogIndex];
    if (!reference) {
      continue;
    }

    items.push({
      key: `fixed:${input.source ?? 'custom'}:${position}:${reference.bookId}:${reference.chapter}`,
      catalogIndex,
      bookId: reference.bookId,
      chapter: reference.chapter,
      label: item.label ?? null,
    });
  }

  if (items.length === 0) {
    return null;
  }

  return {
    kind: 'fixed-list',
    title: input.title ?? null,
    source: input.source ?? null,
    items,
  };
}

export function chapterKey(bookId: number, chapter: number): string {
  return `${bookId}:${chapter}`;
}
